import '../styles/embeddedVideo.scss';
import $ from 'jquery';
import { createProductIconButton } from './modalUtils';


export const tag = `
<div class="wrapper-inmodal">
  <div class="video-container">
    <video autoplay webkit-playsinline playsinline>
      Your browser does not support the video tag.
    </video>
  </div>
</div>
`.trim();


export function init(videoModal, context, productNotice = null, completeCallback = null) {
  const videoElement = $('video', videoModal);
  const wrapperElement = $('.wrapper-inmodal', videoModal);
  if (context.videoId) {
    videoElement.attr('src', context.videoId);
  }
  if (context.productIds) {
    setupProductThumbnails(wrapperElement, videoElement, context);
    if (productNotice) {
      setupProductNotice(wrapperElement, productNotice);
    }
  }
  // 再生完了コールバック
  videoElement[0].addEventListener('ended', function() {
    if (completeCallback) completeCallback(this);
  });
}


function setupProductThumbnails(wrapperElement, videoElement, context) {
  wrapperElement.append('<ul id="product-list"></ul>');
  const buttonElements = createProductIconButton(context.productIds, context, 'url');
  buttonElements.on('click', function () {
    const siteUrl = $(this).val();
    window.open(siteUrl + context.popupManager.getViewHistoryParams());
    videoElement[0].pause();
  });
}


function setupProductNotice(wrapperElement, notice) {
  const container = $('<div class="product-notice"></div>').appendTo(wrapperElement);
  container.html(notice);
}